/**
 * Per-resource roles on a User aggregate. Flat — no hierarchy; gating is
 * membership-only via plain `.includes()`. Values are prefixed with `user:`
 * so roles from different aggregates can be co-located in a single array
 * without ambiguity.
 */

import { z } from "zod";

export const UserRoleSchema = z.enum(["user:admin", "user:event-manager"]);

export type UserRole = z.infer<typeof UserRoleSchema>;

/** Collection schema with parse-time duplicate rejection. */
export const UserRolesSchema = z
  .array(UserRoleSchema)
  .readonly()
  .refine((roles) => new Set(roles).size === roles.length, {
    message: "UserRoles must not contain duplicates",
  });
